import React, { useCallback, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

import './SideBar.css';
import icon1 from '../images/left-icon1.svg'
import icon2 from '../images/left-icon2.svg'
import icon3 from '../images/left-icon3.svg'

const SideBar = () => {
    const location = useLocation();
    const [dash, setDash] = useState(false);

    const Collapse1 = useCallback(() => {
        setDash((dash) => !dash)
    }, [])


    return (
        <div className="left-panel">
            <Link to='/' className="big-btn">
                Upload Data
            </Link>
            <div className="nav-vertical">
                {/* <!-- Collapse --> */}
                <div className="nav-item">
                    <Link to={location.pathname} className={dash ? "nav-link dropdown-toggle" : "nav-link dropdown-toggle active"} onClick={Collapse1}>
                        <i>
                            <img src={icon1} alt='icon' />
                        </i>
                        <span className="nav-link-title">Dashboards</span>
                    </Link>
                    {true && <div className='nav-collapse' >
                        <NavLink className="nav-link " to={`/financed-emissions/${'asset-class'}`}>Financed Emissions</NavLink>
                        <NavLink className="nav-link " to="/climaterisk">Climate Risk Exposure</NavLink>
                    </div>}
                </div>
                <div className="nav-item">
                    <NavLink className="nav-link" to="/reports">
                        <i>
                            <img src={icon2} alt='icon' />
                        </i>
                        <span className="nav-link-title">Reports</span>
                    </NavLink>
                </div>
                <div className="nav-item">
                    <NavLink className="nav-link" to="/helpandsupport">
                        <i>
                            <img src={icon3} alt='icon' />
                        </i>
                        <span className="nav-link-title">Help &amp; Support</span>
                    </NavLink>
                </div>
            </div>
        </div>
    )
}

export default SideBar